import React from 'react';
import BusinessManager from './BusinessManager';

// Removing lazy loading for now
// const BusinessManager = React.lazy(() => import('./BusinessManager'));

export default function BusinessManagerLazy(props) {
  return (
    <React.Suspense fallback={<div>Loading...</div>}>
      <BusinessManager {...props} />
    </React.Suspense>
  );
}
